import request from "../request"
//查询中心领导信息
export function getLeaderIntroductionList(query) {
    return request({
        url: '/centralLeadership/',
        method: 'get',
        params: query
    })
}


// WEBPACK FOOTER //
// ./src/api/summary.js